import {
  Button as ButtonNativeComponent,
  IButtonProps,
  Heading,
  HStack,
} from 'native-base';

type Props = IButtonProps & {
  titleLeft?: string;
  titleRight?: string;
  type: 'Filled' | 'Tinted' | 'Gray' | 'Plain' | 'Select' | 'Selected';
  Icon?: JSX.Element;
}
// outras props:  isLoading isLoadingText
export function Button(
  {
    titleLeft,
    titleRight,
    type,
    Icon,
    ...rest
  }: Props
) {
  return (
    <ButtonNativeComponent
      bg={`Background.${type}`}
      fontFamily="BodyRegular"
      fontSize="Body"
      lineHeight='Body'
      letterSpacing='Body'
      borderRadius={14}
      _pressed={{
        bg: "Background.Tertiary",
      }}
      _hover={{
        bg: "Background.Tertiary",
      }}
      _spinner={{
        color: `Label.${type}`,
      }}
      {...rest}
    >
      <HStack
        alignItems='center'
        justifyContent='space-around'
      >
        {titleLeft &&
          <Heading
            color={`Label.${type}`}
            fontFamily="BodyRegular"
            fontSize='Body'
            lineHeight='Body'
            letterSpacing='Body'
            textAlign='center'
          >
            {titleLeft}
          </Heading>
        }
        {Icon}
        {titleRight &&
          <Heading
            color={`Label.${type}`}
            fontFamily="BodyRegular"
            fontSize="Body"
            lineHeight='Body'
            letterSpacing='Body'
            textAlign='center'
          >
            {titleRight}
          </Heading>
        }
      </HStack>
    </ButtonNativeComponent>
  );
}